module.exports = __webpack_public_path__ + "af42d0254526c7a64cc420165630a749.pdf";